<template>
  <section-vue class="business-blinkist-stats">
    <div class="business-blinkist-stats__container container">
      <div class="grid-css">
        <h2 class="business-blinkist-stats__headline">
          {{ $t("headline") }}
        </h2>

        <div
          v-for="(item, index) in $t('items')"
          :key="index"
          class="business-blinkist-stats__item grid-css__el--xs-12 grid-css__el--m-4"
        >
          <h4 class="business-blinkist-stats__item-stat" v-html="item.stat" />

          <div class="business-blinkist-stats__item-description">
            {{ item.description }}
          </div>

          <div v-if="item.starRating" class="business-blinkist-stats__star-rating">
            <sprite v-for="n in 5" class="business-blinkist-stats__star-rating-icon" :key="n" id="app/star-filled" />
          </div>
        </div>

        <p class="business-blinkist-stats__disclaimer" v-html="$t('disclaimer')" />
      </div>
    </div>
  </section-vue>
</template>

<script>
import SectionVue from "@/shared/section"
import Sprite from "@/shared/sprite"
import "/wds/sprites/app/star-filled.svg"

export default {
  name: "BusinessBlinkistStats",
  components: {
    SectionVue,
    Sprite
  },
  i18n: {
    messages: {
      en: {
        headline: "Blinkist in numbers",
        items: [
          {
            stat: "91%",
            description: " of Blinkist members create a better reading habit*"
          },
          {
            stat: "87%",
            description: "have made positive changes in their lives thanks to Blinkist*"
          },
          {
            stat: "224k+",
            description: "5-star app reviews from happy learners",
            starRating: true
          }
        ],
        disclaimer: "<sup>*</sup> Based on internal study using survey data from general Blinkist customers"
      },
      de: {
        headline: "Der Blinkist-Erfolg in Zahlen",
        items: [
          {
            stat: "91%",
            description: "aller Nutzer lesen mit Blinkist mehr."
          },
          {
            stat: "87%",
            description: "der Kunden haben mit Blinkist positive Veränderungen in ihrem Leben durchgeführt."
          },
          {
            stat: "224&nbsp;<span class='business-blinkist-stats__item-stat--small'>tsd.</span>",
            description: "5-Sterne-Bewertungen in den App-Stores",
            starRating: true
          }
        ],
        disclaimer: "Basierend auf einer Umfrage unter Blinkist-Kunden"
      }
    }
  }
}
</script>

<style lang="scss">
.business-blinkist-stats {
  &__headline {
    @include grid-css-element(12);

    margin-bottom: $spacing-32;

    text-align: center;
  }

  &__item {
    text-align: center;

    &:not(:last-child) {
      margin-bottom: $spacing-32;
    }
  }

  &__item-stat {
    @include font-style(h1, $color: $yellow);

    display: flex;
    justify-content: center;
    align-items: center;
    width: spacing(170px);
    height: spacing(170px);
    margin: 0 auto $spacing-24;

    background-color: $midnight5;

    border-radius: 50%;
  }

  &__item-stat--small {
    @include font-style(h2, $color: $yellow);

    margin-bottom: -0.3em;
  }

  &__item-description {
    @include font-style(p0);

    padding: 0 $spacing-16;
  }

  &__star-rating {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: $spacing-8;
  }

  &__star-rating-icon {
    width: $spacing-32;
    height: $spacing-32;

    color: $blue;

    &:not(:last-child) {
      margin-right: $spacing-4;
    }
  }

  &__disclaimer {
    @include grid-css-element(12);
    @include font-style(legal);

    margin: 0;

    text-align: center;
  }

  @include media(min-width, m) {
    &__headline {
      @include grid-css-element(8, 3);
    }

    &__item {
      margin-bottom: 0;
    }

    &__disclaimer {
      @include grid-css-element(8, 3);
    }
  }
}
</style>
